import React from 'react';
import { Grid2, Alert, Typography } from '@mui/material';
import { isEligibleForAutomaticInProcess } from '../../Utils/ExpenseUtil';

const styles = {
    alert: {
        marginBottom: '16px',
    },
    text: {
        whiteSpace: 'normal',
        overflow: 'visible',
    },
};

const ExpenseAwaitingEndDateAlert = (props) => {
    const { status, endDate } = props;

    if (!isEligibleForAutomaticInProcess(status, endDate)) return null;

    return (
        <Grid2>
            <Alert severity="info" style={styles.alert}>
                <Typography variant="body2" style={styles.text}>
                    This expense will automatically move to <b>In Process</b> tonight.
                </Typography>
            </Alert>
        </Grid2>
    );
};

export default ExpenseAwaitingEndDateAlert;
